var exports = {
  "g": "iconButton__nmq5Kp",
};

module.exports = exports;
